

const PipelineStageButtons = ({onPipelineChange, selectedPipelineStage, pipelineStageCount}) => {
    const handleStatusClick = (status) => {
        const isEqual = Array.isArray(selectedPipelineStage) && 
                       Array.isArray(status) &&
                       selectedPipelineStage.length === status.length &&
                       selectedPipelineStage.every((val, index) => val === status[index]);
                       
        const newPipelineStage = isEqual ? null : status;
        onPipelineChange(newPipelineStage);
    }
    return(
    <div className="justify-between flex">
        <h6 className="text-[#94A3B8]">
          Pipeline Stage:
        </h6>
        <div>
            <button 
            onClick={() => handleStatusClick([1])}
            type="button"
            tabIndex={0}
            className="mx-1"
            >
                <span className="text-[#1E293B] bg-[#FEFAD8] border-[#FEFAD8] w-[46px] h-[34px] py-2 px-4 gap-2 rounded-full border">
                {pipelineStageCount.find(item => item.pipeline_stage === 1)?.count || ""}
                </span>
            </button>
            <button 
            onClick={() => handleStatusClick([2])}
            type="button"
            tabIndex={0}
            className="mx-1"
            >
            <span className="text-[#262BC6] bg-[#BEC2FF] border-[#BEC2FF] w-[46px] h-[34px] pt-2 px-4 pb-2 gap-2 rounded-full border">
                {pipelineStageCount.find(item => item.pipeline_stage === 2)?.count || ""}
            </span>
            </button>
            <button 
            onClick={() => handleStatusClick([3])}
            type="button"
            tabIndex={0}
            className="mx-1"
            >
            <span className="text-[#00658E] bg-[#E3F3FF] border-[#E3F3FF] w-[46px] h-[34px] pt-2 px-4 pb-2 gap-2 rounded-full border">
                {pipelineStageCount.find(item => item.pipeline_stage === 3)?.count || ""}
            </span>
            </button>
            {/* <button
            onClick={() => handleStatusClick([4,5])}
            type="button"
            tabIndex={0}
            className="mx-1"
            >
            <span className="text-[#116D26] bg-[#E7FFD6] border-[#E7FFD6] w-[46px] h-[34px] pt-2 px-4 pb-2 gap-2 rounded-full border">
                {(pipelineStageCount.find(item => item.pipeline_stage === 4)?.count || "") +
                (pipelineStageCount.find(item => item.pipeline_stage === 5)?.count || "")} 
            </span>
            </button> */}
        </div>
    </div>
    )
}
export default PipelineStageButtons;